module.exports = __webpack_public_path__ + "static/media/img-heritage-area8-yahata02.efa135d6.jpg";